import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { COLUMN_INDICATOR_ADJUSTMENT } from 'components/ScalarSpreadsheet/components/content-column/ContentColumns.util';
import { GridSkeletonRootProps, RootProps } from './CustomScalarSpreadsheet.props';

const PREFIX = 'CustomScalarSpreadsheet';

export const classes = {
  loading: `${PREFIX}-loading`,
};

export const Root = styled(Box, {
  shouldForwardProp: prop => !['isDisplayingToolbar', 'spreadsheetWidth'].includes(prop as string),
})<RootProps>(({ isDisplayingToolbar, spreadsheetWidth }) => ({
  position: 'relative',
  transform: 'translateY(-4px)',

  [`& .${classes.loading}`]: {
    margin: 'auto',
    marginLeft: COLUMN_INDICATOR_ADJUSTMENT,
    transform: `translateY(${isDisplayingToolbar ? 0 : COLUMN_INDICATOR_ADJUSTMENT})`,
    visibility: 'hidden',
    width: `calc(${spreadsheetWidth}px - ${COLUMN_INDICATOR_ADJUSTMENT})`,

    '&.active': {
      visibility: 'visible',
    },
  },
}));

// Add width property to GridSkeletonRoot for proper rendering
export const GridSkeletonRoot = styled(Box, {
  shouldForwardProp: prop => !['spreadsheetWidth'].includes(prop as string),
})<GridSkeletonRootProps>(({ spreadsheetWidth }) => ({
  width: `${spreadsheetWidth + 2}px`,
}));
